module.exports = __webpack_public_path__ + "images/services/confluence-page-preview.60108b2281d025898674.svg";